import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation DeleteUserVerifiedPhoneNo($userId: ID!) {
    deleteUserPhoneNumber(userId: $userId)
  }
`

export default mutation
